import urls from "global/constants/UrlConstants";
import { getCallParams, makeCall } from "utils/service";

/** `months` = size of the rolling window in calendar months, including the current month (API contract). */
export const getRenewableCounts = async (months: number) => {
  try {
    const url = `${urls.GET_RENEWABLE_DOCS_COUNT}/${months - 1}`;

    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getRenewableDocumentsByDate = async (startDate: string) => {
  try {
    const url = `${urls.GET_RENEWABLE_DOCUMENTS_BY_DATE}/${startDate}`;

    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error) {
    throw error;
  }
};

export const downloadSignedDocument = async (
  envelopeId: string,
  fileName: string,
) => {
  try {
    const url = `${urls.DOWNLOAD_SIGNED_PDF}/${envelopeId}`;
    const fetchOptions = await getCallParams("POST", { signedPdf: fileName });
    const response = await fetch(url, fetchOptions);
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        errorText || `Download failed with status ${response.status}`,
      );
    }
    return response;
  } catch (error) {
    throw error;
  }
};
